import React from 'react'
import PropTypes from 'prop-types'

export default function Image({ sourceSet, source, crossOrigin, ...rest }) {
  const finalSourceSet = sourceSet
    ? sourceSet.map(({ source: subSource, descriptor }) => `${subSource} ${descriptor}`).join(',')
    : null

  return finalSourceSet ? (
    // eslint-disable-next-line jsx-a11y/alt-text
    <img src={source} srcSet={finalSourceSet} crossOrigin={crossOrigin} {...rest} />
  ) : (
    // eslint-disable-next-line jsx-a11y/alt-text
    <img src={source} {...rest} crossOrigin={crossOrigin} />
  )
}

Image.propTypes = {
  sourceSet: PropTypes.string,
  source: PropTypes.any,
  crossOrigin: PropTypes.string,
}



// WEBPACK FOOTER //
// ./src/components/Image/index.js